import React from "react";
import { TouchableWithoutFeedback, View, Text, StyleSheet } from "react-native";
import {
  CAPTION_STYLES,
  COLORS,
  COMMON_STYLES,
  PARAGRAPH_STYLES,
} from "@dehaat/dds";

interface Props {
  filterCount: number;
  isHighlighted: boolean;
  label: string;
  onClick: () => void;
}

const FilterTab = ({ filterCount, label, onClick, isHighlighted }: Props) => {
  return (
    <TouchableWithoutFeedback onPress={onClick}>
      <View
        style={[
          COMMON_STYLES.pv1,
          COMMON_STYLES["ph1/2"],
          COMMON_STYLES.row,
          COMMON_STYLES.justifyBetween,
          COMMON_STYLES.alignItemsCenter,
          { marginRight: 2 },
          isHighlighted && styles.highlighted,
        ]}
      >
        <Text
          style={[
            PARAGRAPH_STYLES.MediumT1,
            { color: COLORS.neutral90, marginRight: 20, paddingLeft: 12 },
            isHighlighted && { color: COLORS.primary100 },
          ]}
        >
          {label}
        </Text>
        {isHighlighted && <View style={styles.highlightIndicator} />}
        {filterCount > 0 && (
          <View
            style={[
              COMMON_STYLES.absolute,
              COMMON_STYLES.justifyCenter,
              COMMON_STYLES.alignItemsCenter,
              styles.badge,
            ]}
          >
            <Text style={[CAPTION_STYLES.MEDIUM_C1, { color: COLORS.white }]}>
              {filterCount}
            </Text>
          </View>
        )}
      </View>
    </TouchableWithoutFeedback>
  );
};

const styles = StyleSheet.create({
  highlighted: {
    backgroundColor: COLORS.primary10,
  },
  highlightIndicator: {
    borderLeftWidth: 3,
    borderColor: COLORS.primary100,
    top: 8,
    bottom: 8,
    ...COMMON_STYLES.absolute,
  },
  badge: {
    right: 8,
    backgroundColor: COLORS.orange100,
    height: 16,
    width: 16,
    borderRadius: 9999,
  },
});

export default FilterTab;
